import { render } from "./expertDetail.vue?vue&type=template&id=ba94bc14&scoped=true"
import script from "./expertDetail.vue?vue&type=script&lang=js"
export * from "./expertDetail.vue?vue&type=script&lang=js"

import "./expertDetail.vue?vue&type=style&index=0&id=ba94bc14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba94bc14"]])

export default __exports__